import { PhoneCall, Wallet, MonitorSmartphone, ClipboardList, Headset } from "lucide-react";

const steps = [
  { icon: PhoneCall, title: "Get a Call", desc: "An AI Central agent contacts you to walk you through activation." },
  { icon: Wallet, title: "Make a Deposit", desc: "Securely fund your account with the amount you're comfortable with." },
  { icon: MonitorSmartphone, title: "Enter the Platform", desc: "Access your matched, fully regulated trading platform." },
  { icon: ClipboardList, title: "Get Your AI Plan", desc: "Complete a questionnaire and receive a custom financial plan created by AI." },
  { icon: Headset, title: "Start Trading", desc: "A senior account manager calls to help you start trading with confidence." },
];

export const ClientJourney = () => (
  <section id="client-journey" className="px-4 sm:px-6 py-16 scroll-mt-28">
    <div className="max-w-6xl mx-auto">
      <div className="max-w-2xl">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600">Your Journey</span>
        <h2 className="font-heading text-3xl md:text-4xl font-bold tracking-tight text-gray-900 mt-3">
          What Happens After You Activate
        </h2>
        <p className="text-base md:text-lg text-gray-600 mt-4">
          A clear, guided path from first call to your first trade — with real people supporting you at every step.
        </p>
      </div>

      <div data-testid="client-journey-flow" className="mt-14 bg-white border border-gray-200 rounded-2xl p-8 sm:p-12 shadow-sm">
        <div className="relative grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-6">
          <div className="hidden lg:block absolute top-7 left-[10%] right-[10%] border-t-2 border-dashed border-gray-200" />
          {steps.map((s, i) => (
            <div key={i} data-testid={`journey-step-${i + 1}`} className="relative flex lg:flex-col items-start lg:items-center gap-5 lg:gap-0 lg:text-center">
              <div className="relative shrink-0">
                <span className="w-14 h-14 rounded-full bg-blue-600 shadow-lg shadow-blue-600/25 flex items-center justify-center">
                  <s.icon className="w-6 h-6 text-white" />
                </span>
                <span className="absolute -top-1.5 -right-1.5 w-6 h-6 rounded-full bg-gray-900 text-white text-[10px] font-bold flex items-center justify-center border-2 border-white">
                  {i + 1}
                </span>
              </div>
              <div className="lg:mt-5">
                <h3 className="font-heading text-base font-bold text-gray-900">{s.title}</h3>
                <p className="text-xs leading-relaxed text-gray-500 mt-2 max-w-[200px]">{s.desc}</p>
              </div>
              {i < steps.length - 1 && (
                <span className="lg:hidden absolute left-7 top-14 bottom-[-40px] border-l-2 border-dashed border-gray-200" />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
